import React, { useEffect, useState } from "react";
import Table from "../components/table/Table";
import MenuOptions from "../components/threeDots/Menu";
import EditingGroup from "../components/EditingGroup";
import config from "../api/config";
import "../assets/css/customers.css";
import CustomSelect from "../components/select";
import { useDispatch, useSelector } from "react-redux";
import { setToast } from "../redux/actions/ToastAction";
import { Snackbar } from "@mui/material";
import Alert from "../components/alert";

const ChatGroup = () => {
  const [Groups, setGroups] = useState([]);
  const [total, setTotal] = useState(0);
  const [totalgroup, setTotalgroup] = useState(0);
  const [currpage, setCurrPage] = useState(0);
  const [page, setPage] = useState(0);
  const [loading, setLoading] = useState(false);
  const [search, setSearch] = useState("");
  const [size] = useState(100);
  const [role, setRole] = useState(0);
  const roles = ["Все группы", "Группы без категорий"];
   const [bannedBool, setBannedBool] = useState(false);
   const banSelectOptions = ["Забанен", "Доступный"];
  // modal
  const [modal, setModal] = useState(false);
  const [editGroup, setEditGroup] = useState(null);

  // snackbar
  const reducer = useSelector((state) => state.reducer.toast);
  const dispatch = useDispatch();
  const toastHandler = () => {
    dispatch(setToast(false, "success", "Успешно Изменено"));
  };
  // search Group
  const searchHandler = (e) => {
    setSearch(e.target.value);
    setLoading(true);
    config
      .get(`/api/chatGroup/v1?search=${e.target.value}&size=${size}&isKickedOut=${bannedBool}`)
      .then((data) => {
        setLoading(false);
        setGroups(data.data.objectKoinot.content);
        setTotal(data.data.objectKoinot.totalPages);
        setCurrPage(data.data.objectKoinot.number);
      })
      .catch((err) => {
        setLoading(false);
      });
  };

  // change pages
  const pageHandler = (page) => {
    setLoading(true);
    setPage(page);
    config
      .get(`/api/chatGroup/v1?page=${page}&size=${size}&isKickedOut=${bannedBool}`)
      .then((data) => {
        setLoading(false);
        setGroups(data.data.objectKoinot.content);
        setTotal(data.data.objectKoinot.totalPages);
        setCurrPage(data.data.objectKoinot.number);
      })
      .catch((err) => {
        setLoading(false);
      });
  };

  // rolechanger
  const roleHandler = (index) => {
    setRole(index);
    setLoading(true);
    setPage(page);
    config
      .get(`/api/chatGroup/v1?search=${search}&size=${size}&isKickedOut=${bannedBool}`)
      .then((data) => {
        setLoading(false);
        if (role !== 1) setGroups(data.data.objectKoinot.content);
        setTotal(data.data.objectKoinot.totalPages);
        setCurrPage(data.data.objectKoinot.number);
      })
      .catch((err) => {
        setLoading(false);
      });
    if (totalgroup === 0) {
      config
        .get("/api/statistics/v1/getCount")
        .then((data) => setTotalgroup(data.data.objectKoinot.countGroup));
    }
  };
  // rolechanger banned
  const roleHandlerBanning = (bool) => {
    setBannedBool(bool);
    setLoading(true);
    setPage(page);
    config
      .get(`/api/chatGroup/v1?search=${search}&size=${size}&isKickedOut=${bannedBool}`)
      .then((data) => {
        setLoading(false);
        if (role !== 1) setGroups(data.data.objectKoinot.content);
        setTotal(data.data.objectKoinot.totalPages);
        setCurrPage(data.data.objectKoinot.number);
      })
      .catch((err) => {
        setLoading(false);
      });
  };

  // get data
  useEffect(() => {
    setLoading(true);
    config.get("/api/chatGroup/v1", { params: { size: 100, isKickedOut: false } })
      .then(({ data }) => {
        setGroups(data.objectKoinot.content);
        setTotal(data.objectKoinot.totalPages);
        setCurrPage(data.objectKoinot.number);
      }).catch(() => dispatch(setToast(true, "error", "Не удалось загрузить группы")))
      .finally(() => setLoading(false));
    config.get("/api/statistics/v1/getCount")
      .then(({ data }) => setTotalgroup(data.objectKoinot.countGroup))
      .catch(() => {});
  }, [dispatch]);

  // save edited Group
  const saveHandler = async (bool, object) => {
    if (bool) {
      try {
        await config.post(`/api/chatGroup/v1`, object);
        setModal(false);
        roleHandler(page);
        dispatch(setToast(true, "success", "Успешно Изменено"));
      } catch (e) {
        throw e

      }
    }
  };

  // table data
  const headData = ["Имя", "Область", "Категория", "Статус"];
  const renderHead = (item, index) => <th key={index}>{item}</th>;
  // menu data
  const renderBody = (item, index) => (
    <tr key={index}>
      <td>
        <p>{item.name}</p>
      </td>
      <td className="">
        <span> {item.region} </span>
      </td>
      <td>
        <p> {item.resCategory ? item.resCategory.nameRu : "Без категории"}</p>
      </td>
      <td>
        <p> {item.isKickedOut ? "Забанен" : "Доступный"}</p>
      </td>
      <td>
        <MenuOptions
          options={[
            {
              value: "Изменять",
              callback: () => {
                setEditGroup(item);
                setModal(true);
              },
            },
          ]}
        />
      </td>
    </tr>
  );

  return (
    <div>
      <Snackbar
        open={reducer.toast}
        autoHideDuration={4000}
        onClose={toastHandler}
      >
        <Alert
          onClose={toastHandler}
          severity={reducer.severity}
          sx={{ width: "100%" }}
        >
          {reducer.content}
        </Alert>
      </Snackbar>
      <EditingGroup
        group={editGroup}
        _callback={saveHandler}
        modal={modal}
        setModal={() => setModal(!modal)}
      />
      <h2 className="page-header">Группы</h2>
      {totalgroup > 0 && (
        <p className="fw-bold">
          Общее количество групп:
          <span className="fw-bold second-color">{totalgroup}</span>
        </p>
      )}
      <div className="row pb-5">
        <div className="col-12">
          <div className="row">
            <div className="col-md-6 col-sm-12">
              <input type="text" value={search} onChange={searchHandler} />
            </div>
            <div className="col-md-6 col-sm-12">
              <CustomSelect
                selVal={role}
                selItems={roles}
                type={"outlined"}
                selHandle={(e) => {
                  roleHandler(e);
                }}
              />
              <CustomSelect
                className="ms-2"
                selVal={bannedBool}
                selItems={banSelectOptions}
                type={"outlined"}

                selHandle={(e) => {
                  roleHandlerBanning(e);
                }}
              />
            </div>
            <div className="col-md-6 col-sm-12 "></div>
          </div>

          <Table
            headData={headData}
            renderHead={(item, index) => renderHead(item, index)}
            bodyData={Groups}
            renderBody={(item, index) => renderBody(item, index)}
            pages={total}
            currPage={currpage}
            changePage={pageHandler}
            loading={loading}
          />
        </div>
      </div>
    </div>
  );
};

export default ChatGroup;
